import React, { useRef, useEffect, useState } from "react";

import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import SnackAlert from '../SnackAlert';
import OnboardingModal from '../OnboardingModal';

import { getCollapsed, setCollapsed } from "src/Api/services/storageService";
import { useDeviceType } from "src/Utils/useDeviceType";


function Navigation(props) {

  const { children: SubComp, title, subtitle } = props;
  const { isDesktop } = useDeviceType();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);


  const collapsed = (collapsed)=>{

    setSidebarCollapsed(collapsed);
    setCollapsed(collapsed);

  }

  useEffect(() => {
    const collapsed = getCollapsed();
    setSidebarCollapsed( collapsed || false);
  }, []);

  useEffect(() => {
    setSidebarOpen(isDesktop);
  }, [isDesktop]);

  // En mobile/tablet: cuando el sidebar se abre, forzar expandido (con texto)
  useEffect(() => {
    if (sidebarOpen && !isDesktop) {
      setSidebarCollapsed(true);
    }
  }, [sidebarOpen, isDesktop]);


  return (
    <div className='bg-slate'>
      <div className="flex overflow-hidden">
        <Sidebar
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={collapsed}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <div className={`${!isDesktop ? 'ml-0' : sidebarCollapsed ? "ml-56 lg:ml-60" : "ml-12"} h-screen w-full relative overflow-y-auto`}>
          <Navbar
            title={title}
            subtitle={subtitle}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
          {/* <main className='h-full px-2'> */}
          <main className='px-2'>
            <SnackAlert/>
            <SubComp />
          </main>
        </div>
      </div>
      <OnboardingModal />
    </div>
  )
}
export default Navigation
